module.exports = __webpack_public_path__ + "img/map_Z5.4.A.01.46a75dcd.svg";